import styles from './Footer.module.css'
import { useInView } from 'react-intersection-observer'
import dynamic from 'next/dynamic'
import { ReactNode } from 'react'
import { BasicStyledComponent, LinkedLinkProps } from 'shared-definitions/types'

export interface FooterProps {
  logo: React.FC<BasicStyledComponent>
  children?: ReactNode
  logoLink: LinkedLinkProps
}

const FooterContent = dynamic(() => import('shared-components/layout/FooterContent'), {
  ssr: false,
})

const Footer: React.FC<FooterProps> = props => {
  const { ref, inView } = useInView({ triggerOnce: true })

  return (
    <footer ref={ref} className={styles.container}>
      {inView ? <FooterContent {...props} /> : null}
    </footer>
  )
}

export default Footer
